import { render, staticRenderFns } from "./saleGoodsDetail.vue?vue&type=template&id=6117d8ab&scoped=true&"
import script from "./saleGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./saleGoodsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117d8ab",
  null
  
)

export default component.exports